import { call, put, takeEvery } from "redux-saga/effects";
import { sagaTypes } from "./types";
import { IData, IDataPage } from "../../interfaces/common";
import { IAction } from "../utils";
import { getContactUs, getContactUsAll } from "../../api/contactUs";
import {
  getMoreContactUsAction,
  getContactUsAction,
  getAllContactUsAction,
  setSizePageAction,
} from "./action";
import { IContactUs } from "../../interfaces/contactUs";

export function* getAllContactUsWorkerSaga({ payload }: IAction<string>) {
  const res: IDataPage<IContactUs[]> = yield call(getContactUsAll, payload as string);
  yield put(getAllContactUsAction(res?.data?.items || []));
  if (res?.data) {
    const { pageSize, totalPages, totalCount, pageIndex } = res?.data;
    yield put(
      setSizePageAction({ pageSize, totalPages, totalCount, pageIndex })
    );
  }
}

export function* getMoreContactUsWorkerSaga({ payload }: IAction<string>) {
  const res: IDataPage<IContactUs[]> = yield call(getContactUsAll, payload as string);
  yield put(getMoreContactUsAction(res?.data?.items || []));
  if (res?.data) {
    const { pageSize, totalPages, totalCount, pageIndex } = res?.data;
    yield put(
      setSizePageAction({ pageSize, totalPages, totalCount, pageIndex })
    );
  }
}

export function* getContactUsWorkerSaga({ payload }: IAction<string>) {
  const res: IData<IContactUs> = yield call(getContactUs, payload as string);
  yield put(getContactUsAction(res?.data));
}

export function* contactUsWatcherSaga() {
  yield takeEvery(sagaTypes?.GET_ALL_CONTACTUS, getAllContactUsWorkerSaga);
  yield takeEvery(sagaTypes?.GET_MORE_CONTACTUS, getMoreContactUsWorkerSaga);
  yield takeEvery(sagaTypes?.GET_CONTACTUS, getContactUsWorkerSaga);
}
